module.exports = {
    'Book a viewing': 'Mehr erfahren',
    close: 'Schließen',
    Title: 'Anrede*',
    Mr: 'Herr',
    Mrs: 'Frau',
    Email: 'E-Mail*',
    Firstname: 'Vorname*',
    Lastname: 'Nachname*',
    Message: 'Mitteilung',
    Checkbox_updates: 'Klicken Sie hier, um Updates zu anderen Entwicklungen in Andermatt Swiss Alps zu erhalten',
    Form_GDPR:
        'Mit dem Versand dieses Formulars bestätigen Sie, dass Sie mit der <a href="https://www.andermatt-swissalps.ch/datenschutzerklaerung/" target="_blank">Datenschutzerklärung</a> einverstanden sind.',
    'Privacy Policy': 'Datenschutzerklärung',
    privacyLink: 'https://www.andermatt-swissalps.ch/datenschutzerklaerung/',
    Submit: 'Absenden',
    Submiting: 'Absenden',
    'Title is required': 'Anrede ist erforderlich',
    'First name must be at least 2 characters': 'Vorname muss mindestens 2 Zeichen lang sein',
    'First name is required': 'Vorname ist erforderlich',
    'Last name is required': 'Nachname ist erforderlich',
    'Last name must be at least 2 characters': 'Nachname muss mindestens 2 Zeichen lang sein',
    'Invalid email': 'Ungültige E-Mail',
    'Email is required': 'E-Mail ist erforderlich',
    'Message is required': 'Mitteilung ist erforderlich',
    'Thank you for getting in touch.': 'Wir haben Ihre Nachricht erhalten und melden uns in Kürze bei Ihnen.',
    'There was an issue submitting the form.': 'Beim Senden des Formulars ist ein Problem aufgetreten.',
    'Scroll Down': 'Nach unten scrollen',
    'Cookie settings': 'Cookie-Einstellungen',
    CookiesMessage:
        'Die Webseite verwendet Cookies: Cookies helfen uns bei der Bereitstellung unserer Dienste. Durch die Nutzung unserer Dienste erklären Sie sich damit einverstanden, dass wir Cookies setzen. ',
    'Learn more': 'Mehr erfahren',
    CookiesLink: 'https://www.andermatt-swissalps.ch/de/cookies',
    ACCEPT: 'AKZEPTIEREN',
    Brochure: 'Broschüre',
    Available: 'Verfügbar',
    Reserved: 'Reserviert ',
    Sold: 'Verkauft',
    Residence: 'Residence',
    Unit: 'Einheit',
    'Unit No.': 'EINHEIT',
    Floor: 'ETAGE',
    Bedrooms: 'SCHLAFZIMMER',
    Type: 'Typ',
    Entrance: 'Eingang',
    'Sq. metres': 'Quadratmeter',
    Size: 'GRÖSSE',
    Balcony: 'Loggia',
    Availability: 'Verfügbarkeit',
    Floorplans: 'Grundriss',
    Price: 'Preis',
    Download: 'Herunterladen',
    'Price list': 'Preisliste',
    Yes: 'Ja',
    No: '',
    'contact us': 'KONTAKT',
    'View position in building': 'Position auf der Etage',
    'View floorplan': 'Grundriss'
}
